// Import slick-carousel
import 'slick-carousel'
import 'slick-carousel/slick/slick.scss'